"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = exports.getKeys = void 0;
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var imports_1 = require("@lib/imports");
var common_sidecar_1 = require("@main/common-sidecar");
var textInputs_sidecar_1 = require("@uiParts/textInputs-sidecar");
var voyageCamera_shaker_sidecar_1 = require("@voyage/camera/voyageCamera_shaker-sidecar");
var voyageGameManager_sidecar_1 = require("@voyage/game-status/voyageGameManager-sidecar");
var voyageGameMode_tutorial_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_tutorial-sidecar");
var voyageMessageHostCommand_1 = require("@voyage/multi/voyageMessageHostCommand");
var voyageMessageHostCommand_sidecar_1 = require("@voyage/multi/voyageMessageHostCommand-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var voyageTestParams_sidecar_1 = require("@voyage/scene/voyageTestParams-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
var voyagePicker_sidecar_1 = require("@voyage/ui-cursors/voyagePicker-sidecar");
var crokinoleUi_menu_gameEsc_sidecar_1 = require("@crokinole/ui-menus/crokinoleUi_menu_gameEsc-sidecar");
var diveMultiUtilities_syncWorld_sidecar_1 = require("@dive/multi/diveMultiUtilities_syncWorld-sidecar");
var diveSaver_all_sidecar_1 = require("@dive/saver/diveSaver_all-sidecar");
var perf2_sidecar_1 = require("@engine/perf2-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var diveMessage_hostCommand_1 = require("@voyage/multi/diveMessage_hostCommand");
var diveMessage_hostCommand_sidecar_1 = require("@voyage/multi/diveMessage_hostCommand-sidecar");
var diveMessage_simulationSync_sidecar_1 = require("@voyage/multi/diveMessage_simulationSync-sidecar");
var voyageTilemapEditor_sidecar_1 = require("@voyage/tilemap/voyageTilemapEditor-sidecar");
var voyageToolBodyAlign_sidecar_1 = require("@voyage/tools/voyageToolBodyAlign-sidecar");
var crokinoleGameState_sidecar_1 = require("proto/crokinole/main/crokinoleGameState-sidecar");
var namespace = 'keys-voyager';
var keys = {
    godMode: false,
    shift: false,
    control: false,
    alt: false,
    cameraUp: false,
    cameraDown: false,
    cameraLeft: false,
    cameraRight: false,
};
var getKeys = function () {
    return keys;
};
exports.getKeys = getKeys;
var _handlers = [];
var addHandler = function (codes, on, off, change) {
    if (on === void 0) { on = function () { }; }
    if (off === void 0) { off = function () { }; }
    if (change === void 0) { change = function () { }; }
    if (!imports_1.l.isArray(codes)) {
        codes = [codes];
    }
    imports_1.l.forEach(codes, function (c) {
        _handlers.push({ code: c, on: on, off: off, change: change });
    });
};
var addKey = function (codes, property) {
    addHandler(codes, function () { }, function () { }, function (isDown) {
        // console.log('key property changed', codes, property, isDown)
        keys[property] = isDown;
    });
};
var create = function () {
    var s = common_sidecar_1.common.getPhaserScene();
    imports_1.l.forEach(textInputs_sidecar_1.textInputs.textInputAlphabet, function (c) {
        s.input.keyboard.addKey(c);
    });
    var isEditor = function () {
        return voyageGameManager_sidecar_1.voyageGameManager.get().mode === 'editor';
    };
    var isBodyAlign = function () {
        return voyageGameManager_sidecar_1.voyageGameManager.get().mode === 'body-align';
    };
    console.log(namespace, 'create voyage keyboard');
    addKey(['ShiftLeft', 'ShiftRight'], 'shift');
    addKey(['ControlLeft', 'ControlRight'], 'control');
    addKey(['AltLeft', 'AltRight'], 'alt');
    addKey(['KeyW', 'ArrowUp'], 'cameraUp');
    addKey(['KeyA', 'ArrowLeft'], 'cameraLeft');
    addKey(['KeyS', 'ArrowDown'], 'cameraDown');
    addKey(['KeyD', 'ArrowRight'], 'cameraRight');
    s.input.keyboard.addKey('Space');
    addHandler('Space', function () {
        voyageGameManager_sidecar_1.voyageGameManager.togglePause();
    });
    s.input.keyboard.addKey('ESC');
    addHandler('Escape', function () {
        voyagePicker_sidecar_1.voyagePicker.clearSelection();
        // TODO: is crokinole running?
        // if(crokinoleUi_menu_main.isOpen('game-esc')) {
        //   crokinoleUi_menu_main.setOpen(false)
        // }
        // TODO: only if in game and crokinole running?
        // console.log('hit escape!!')
        crokinoleUi_menu_gameEsc_sidecar_1.crokinoleUi_menu_gameEsc.toggleOpen();
    });
    s.input.keyboard.addKey(34); // Pagedown
    addHandler('PageDown', function () {
        diveSaver_all_sidecar_1.diveSaver_all.write_toLocalStorage();
    });
    s.input.keyboard.addKey(33); // Pagedown
    addHandler('PageUp', function () {
        // voyageScenarioSaver.load()
        // voyageGameManager.goScenario_load()
        // Read our saved data
        if (diveSaver_all_sidecar_1.diveSaver_all.read_fromLocalStorage()) {
            if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
                // Tell everyone to reload too
                diveMultiUtilities_syncWorld_sidecar_1.diveMultiUtilities_syncWorld.diveMulti_syncWorld();
            }
        }
    });
    s.input.keyboard.addKey('END');
    addHandler('End', function () {
        if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
            // l.forEach(diveCrew.getAll(), (c) => {
            //   if (c.type === EVoyageCrewType.Crew) {
            //     voyageMessageCrewHurt.sendMessageAndImmediatelyExecute({
            //       crewId: c.id,
            //       newHitpoints: -100,
            //       type: EVoyageCrewDamageType.Suicide,
            //       byCrewId: 0,
            //     })
            //     // diveCrew.makeDeadish(c, EVoyageCrewDamageType.Suicide) //'Suicide')
            //   }
            // })
        }
    });
    s.input.keyboard.addKey('HOME');
    addHandler('Home', function () {
        if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
            console.log(namespace, 'Home, creating new world');
            // Pause (TODO: move to host command?)
            diveMessage_simulationSync_sidecar_1.diveMessage_simulationSync.send(false);
            diveMessage_hostCommand_sidecar_1.diveMessage_hostCommand.sendMessageToAll({
                hostCommand: diveMessage_hostCommand_1.EDiveHostCommand.NewScenario,
                message: 'Creating new game...',
            });
            // // TODO: implement this to create a whole noew world
            // voyageMessageHostCommand.sendMessageAndImmediatelyExecute({
            //   command: EHostCommand.NewScenario,
            // })
        }
        else {
            // Try to join
            console.log(namespace, 'Home, joining channel');
            websockets_sidecar_1.websockets.joinChannel('test', false, true, '');
        }
    });
    // document.onkeypress(ev)
    s.input.keyboard.addKey('TAB');
    addHandler('Tab', function () {
        voyagePicker_sidecar_1.voyagePicker.nextSelection(1);
        //let keys = getKeys()
        //voyagePicker.nextSelection(keys.shift ? -1 : 1)
    });
    addHandler('Backquote', function () {
        voyagePicker_sidecar_1.voyagePicker.nextSelection(-1);
        //let keys = getKeys()
        //voyagePicker.nextSelection(keys.shift ? -1 : 1)
    });
    addHandler('KeyP', function () {
        voyageSounds_sidecar_1.voyageSounds.toggleSounds();
    });
    addHandler('KeyM', function () {
        voyageSounds_sidecar_1.voyageSounds.toggleMusic();
    });
    addHandler('KeyX', function () {
        voyageGameMode_tutorial_sidecar_1.voyageGameMode_tutorial.signalSkip();
    });
    addHandler('KeyR', function () {
        if (websockets_sidecar_1.websockets.getIsHost()) {
            voyageMessageHostCommand_sidecar_1.voyageMessageHostCommand.sendMessageAndImmediatelyExecute({
                command: voyageMessageHostCommand_1.EHostCommand.old_Reset,
            });
        }
    });
    if (voyageTestParams_sidecar_1.voyageTestParams.isDevMode) {
        addHandler('KeyE', function () {
            voyageCamera_shaker_sidecar_1.voyageCamera_shaker.shake();
        });
        addHandler('Digit1', function () {
            voyageTilemapEditor_sidecar_1.voyageTilemapEditor.get().mode = 'old';
            voyageTilemapEditor_sidecar_1.voyageTilemapEditor.get().layerIdx = 1;
        });
        addHandler('Digit2', function () {
            voyageTilemapEditor_sidecar_1.voyageTilemapEditor.get().mode = 'old';
            voyageTilemapEditor_sidecar_1.voyageTilemapEditor.get().layerIdx = 2;
        });
        addHandler('Digit3', function () {
            voyageTilemapEditor_sidecar_1.voyageTilemapEditor.get().mode = 'old';
            voyageTilemapEditor_sidecar_1.voyageTilemapEditor.get().layerIdx = 3;
        });
        addHandler('Digit4', function () {
            voyageTilemapEditor_sidecar_1.voyageTilemapEditor.get().cutMode = !voyageTilemapEditor_sidecar_1.voyageTilemapEditor.get().cutMode;
        });
        addHandler('Digit5', function () {
            voyageTilemapEditor_sidecar_1.voyageTilemapEditor.get().mode = 'hull';
        });
        addHandler('Digit6', function () {
            voyageTilemapEditor_sidecar_1.voyageTilemapEditor.get().mode = 'sys';
        });
        addHandler('Digit7', function () {
            voyageTilemapEditor_sidecar_1.voyageTilemapEditor.get().mode = 'floor';
        });
        addHandler('Digit8', function () {
            voyageTilemapEditor_sidecar_1.voyageTilemapEditor.get().mode = 'decor';
        });
        addHandler('Delete', function () {
            voyageTilemapEditor_sidecar_1.voyageTilemapEditor.clearArea();
        });
        addHandler('KeyJ', function () {
            voyageTilemapEditor_sidecar_1.voyageTilemapEditor.cut(-1, 0);
        });
        addHandler('KeyL', function () {
            voyageTilemapEditor_sidecar_1.voyageTilemapEditor.cut(1, 0);
        });
        addHandler('KeyI', function () {
            voyageTilemapEditor_sidecar_1.voyageTilemapEditor.cut(0, -1);
        });
        addHandler('KeyK', function () {
            voyageTilemapEditor_sidecar_1.voyageTilemapEditor.cut(0, 1);
        });
        addHandler('Numpad1', function () {
            voyageTestParams_sidecar_1.voyageTestParams.setTestMode('normal');
        });
        addHandler('Numpad2', function () {
            voyageTestParams_sidecar_1.voyageTestParams.setTestMode('editor');
        });
        addHandler('Numpad3', function () {
            voyageTestParams_sidecar_1.voyageTestParams.setTestMode('game');
        });
        addHandler('Numpad4', function () {
            voyageTestParams_sidecar_1.voyageTestParams.setTestMode('body-align');
        });
        addHandler('Numpad5', function () {
            voyageTestParams_sidecar_1.voyageTestParams.setTestMode('test');
        });
        addHandler('Numpad6', function () {
            voyageTestParams_sidecar_1.voyageTestParams.setTestMode('mp-test');
        });
        addHandler('Numpad7', function () {
            voyageTestParams_sidecar_1.voyageTestParams.setTestMode('gen-test');
        });
        addHandler('Numpad8', function () {
            voyageTestParams_sidecar_1.voyageTestParams.setTestMode('crokinole-main-menu');
        });
        addHandler('Numpad9', function () {
            voyageTestParams_sidecar_1.voyageTestParams.setTestMode('crokinole');
        });
        addHandler('KeyN', function () {
            crokinoleGameState_sidecar_1.crokinoleGameState.reset();
        });
        addHandler('Equal', function () {
            perf2_sidecar_1.perf2.report();
        });
        // addHandler('Numpad9', () => {
        //   // Regen
        //   // TODO: move to next level?
        //   diveTilemapGenerator.generate_initial_scenario_level(
        //     true,
        //     false,
        //     1,
        //     false,
        //   )
        // })
        addHandler('KeyA', function () {
            if (isBodyAlign()) {
                voyageToolBodyAlign_sidecar_1.voyageToolBodyAlign.adjust(-1, 0, 0, 0);
            }
        });
        addHandler('KeyD', function () {
            if (isBodyAlign()) {
                voyageToolBodyAlign_sidecar_1.voyageToolBodyAlign.adjust(1, 0, 0, 0);
            }
        });
        addHandler('KeyW', function () {
            if (isBodyAlign()) {
                voyageToolBodyAlign_sidecar_1.voyageToolBodyAlign.adjust(0, -1, 0, 0);
            }
        });
        addHandler('KeyS', function () {
            if (isBodyAlign()) {
                voyageToolBodyAlign_sidecar_1.voyageToolBodyAlign.adjust(0, 1, 0, 0);
            }
        });
        addHandler('ArrowLeft', function () {
            if (isBodyAlign()) {
                voyageToolBodyAlign_sidecar_1.voyageToolBodyAlign.adjust(0, 0, -1, 0);
            }
        });
        addHandler('ArrowRight', function () {
            if (isBodyAlign()) {
                voyageToolBodyAlign_sidecar_1.voyageToolBodyAlign.adjust(0, 0, 1, 0);
            }
        });
        addHandler('ArrowUp', function () {
            if (isBodyAlign()) {
                voyageToolBodyAlign_sidecar_1.voyageToolBodyAlign.adjust(0, 0, 0, -1);
            }
        });
        addHandler('ArrowDown', function () {
            if (isBodyAlign()) {
                voyageToolBodyAlign_sidecar_1.voyageToolBodyAlign.adjust(0, 0, 0, 1);
            }
        });
        addHandler('Numpad7', function () {
            if (isEditor()) {
                voyageTilemapEditor_sidecar_1.voyageTilemapEditor.runFixer();
            }
            if (isBodyAlign()) {
                voyageToolBodyAlign_sidecar_1.voyageToolBodyAlign.get().bodyIdx++;
            }
        });
        addHandler('Numpad8', function () {
            if (isEditor()) {
                voyageTilemapEditor_sidecar_1.voyageTilemapEditor.runPaintFloors(voyageColors_sidecar_1.voyageColors.g1);
            }
            if (isBodyAlign()) {
                voyageToolBodyAlign_sidecar_1.voyageToolBodyAlign.get().headIdx++;
            }
        });
        addHandler('Numpad9', function () {
            if (isEditor()) {
                voyageTilemapEditor_sidecar_1.voyageTilemapEditor.runPaintFloors(0x00ff00);
            }
            if (isBodyAlign()) {
                voyageToolBodyAlign_sidecar_1.voyageToolBodyAlign.get().hairIdx++;
            }
        });
    }
    console.log(namespace, 'add keyboard handler');
    s.input.keyboard.on('keydown', function (event) {
        console.log(namespace, 'key down', 'key', event.key, 'keyCode', event.keyCode, 'code', event.code);
        // if (underMenuController.handleKeydown(event.code)) {
        //   return
        // }
        if (textInputs_sidecar_1.textInputs.hasFocus()) {
            textInputs_sidecar_1.textInputs.handleKeyboardInput(event.key, event.keyCode, event.code);
        }
        else {
            imports_1.l.forEach(_handlers, function (c) {
                if (c.code === event.code) {
                    console.log(namespace, 'hit handler');
                    if (c.on) {
                        c.on();
                    }
                    if (c.change) {
                        c.change(true);
                    }
                }
            });
        }
    });
    s.input.keyboard.on('keyup', function (event) {
        if (textInputs_sidecar_1.textInputs.hasFocus()) {
            textInputs_sidecar_1.textInputs.handleKeyboardInput(event.key, event.keyCode, event.code);
        }
        else {
            imports_1.l.forEach(_handlers, function (c) {
                if (c.code === event.code) {
                    if (c.off) {
                        c.off();
                    }
                    if (c.change) {
                        c.change(false);
                    }
                }
            });
        }
    });
};
exports.create = create;
